import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        this.el.$on('submit', (e) => {
            e.preventDefault();
            this.submit();
        });
    }

    submit() {
        console.log('FormPret submit');
        const fd = new FormData(this.el);
        fd.append('action', 'stereo_form_pret');
        fd.append('Page actuelle', window.location.href);
        fd.append('Page précédente', document.referrer);

        fetch('/wp/wp-admin/admin-ajax.php', {
            method: 'post',
            body: fd
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.el.reset();
                    this.el.nextElementSibling.style.display = 'block';
                }
                else {
                    alert('Error')
                }
            });
    }

    destroy() {
        this.el.$off('submit');
    }
}
